import React, { useRef, useEffect } from 'react';
import ModalOverlay from './ModalOverlay';

const AdjustedModalOverlay = ({ isShowAdjustedModal, setIsShowAdjustedModal }) => {
    const modalRef = useRef(null);

    /**
     * Open the modal after the first render.
     */
    useEffect(() => {
        modalRef.current.open = true;
    }, [modalRef]);

    /**
     * Listen for the close event on the modal overlay.
     * Whenever it's closed, wait for the fade-out transition to complete
     * before destroying the component.
     */
    useEffect(() => {
        modalRef.current.addEventListener('modaloverlaychange', event => {
            if (event.detail.isOpen === false) {
                event.target.addEventListener(
                    'transitionend',
                    () => {
                        setIsShowAdjustedModal(prevState => ({
                            ...prevState,
                            adjustment_modal:   false
                        }));
                    },
                    { once: true }
                );
            }
        });
    }, [setIsShowAdjustedModal]);

    return (
        <ModalOverlay ref={modalRef}>
            {isShowAdjustedModal.adjustment_state === false ? (
                <>
                    <div dangerouslySetInnerHTML={{__html: isShowAdjustedModal.adjustment_text_false}} />
                </>
            ) : (
                <>
                    <dive dangerouslySetInnerHTML={{__html: isShowAdjustedModal.adjustment_text_true}} />
                </>
            )}
        </ModalOverlay>
    );
}

export default AdjustedModalOverlay;
